import * as React from "react";
import { Loader2 } from "lucide-react";

import { cn } from "../../lib/utils";

const sizeClasses = {
  sm: "h-5 w-5",
  md: "h-8 w-8",
  lg: "h-10 w-10",
};

const LoadingSpinner = React.forwardRef(
  ({ className, label, size = "md", centered = false, ...props }, ref) => (
    <div
      ref={ref}
      role="status"
      aria-live="polite"
      aria-busy="true"
      className={cn(
        "loading-spinner",
        centered && "loading-spinner--centered",
        className
      )}
      {...props}
    >
      <Loader2
        className={cn(sizeClasses[size] || sizeClasses.md, "animate-spin text-primary")}
        aria-hidden="true"
      />
      {label ? <span className="loading-spinner-label">{label}</span> : null}
      {!label ? <span className="sr-only">Loading</span> : null}
    </div>
  )
);
LoadingSpinner.displayName = "LoadingSpinner";

export { LoadingSpinner };
